import React, { useEffect, useState, useRef } from 'react';
import useIsScrolled from 'hooks/useIsScrolled';
import useDomElement from 'hooks/useDomElement';
import getBreakpointView from 'utils/getBreakpointView';
import useScrollPosition from 'hooks/useScrollPosition';
import useExternalBanner from 'hooks/useExternalBanner';
import chatBubbleIcon from './images/chat-bubble.svg';
import setActiveItemIndexAndScroll from './utils/setActiveItemIndexAndScroll';
import AnchorMenuLogo from './AnchorMenuLogo';
import AnchorMenu from './AnchorMenu';
import MobileCallToAction from './AnchorMenuMobileCta';
import ContentfulCallToAction from 'components/Contentful/ContentfulCallToAction';

import { AnchorMenuHeader, Container, InnerContainer } from './styles';

const AnchorLinkNavigation = ({ navigation, contextualCta, isHeroDark }) => {
  const [isSticky, setIsSticky] = useState(false);
  const [navPosition, setNavPosition] = useState(0);
  const [activeIndex, setActiveIndex] = useState(-1);
  const { isScrolled } = useIsScrolled(100);
  const containerRef = useRef();
  const isMobile = getBreakpointView(['xs', 'sm']);
  const isXsScreen = getBreakpointView(['xs']);
  const isDesktop = !isMobile;
  const breakpointIdentified = isMobile !== null;
  const displayAnchorMenuCta = contextualCta && isDesktop && breakpointIdentified && isScrolled;
  const displayMobileCta = contextualCta && isMobile && isSticky && breakpointIdentified;
  const driftIcon = useDomElement('#drift-frame-controller');

  useEffect(() => {
    if (driftIcon && isXsScreen) {
      driftIcon.style.right = '5px';
      driftIcon.style.bottom = isSticky ? '100px' : '5px';
    }
  }, [driftIcon, isSticky]);

  useScrollPosition(() => {
    const scrollPosition = window.pageYOffset;
    const isNavSticky = scrollPosition > navPosition && isScrolled;

    setIsSticky(isNavSticky);
  });

  useEffect(() => {
    if (isScrolled) {
      const navigationPosition = containerRef.current.offsetTop;
      setNavPosition(navigationPosition);
    }
  }, [containerRef, isScrolled]);

  useEffect(() => {
    setActiveItemIndexAndScroll(navigation, setActiveIndex);
  }, []);

  const handleDriftClick = () => {
    if (window.drift) {
      window.drift.api.startInteraction({ interactionId: 285462 });
    }
  };

  const { bannerHeight } = useExternalBanner();

  return (
    <>
      {breakpointIdentified && (
        <AnchorMenuHeader isMobile={isMobile}>
          <>
            <AnchorMenuLogo isHeroDark={isHeroDark} isScrolled={isScrolled} />
            <button
              className="in-page-subnav--contextualCta-drift"
              onClick={() => handleDriftClick()}
            >
              <img src={chatBubbleIcon} />
              {!isXsScreen && <p>Chat with us</p>}
            </button>
          </>
        </AnchorMenuHeader>
      )}
      {isScrolled && (
        <Container
          isDesktop={isDesktop}
          isMobile={isMobile}
          isScrolled={isScrolled}
          isSticky={isSticky}
          ref={containerRef}
          bannerHeight={bannerHeight}
        >
          <InnerContainer
            firstActive={activeIndex === 0}
            isMobile={isMobile}
            isScrolled={isScrolled}
            lastActive={activeIndex === navigation?.navigation?.length - 1}
          >
            <AnchorMenu
              activeIndex={activeIndex}
              cta={contextualCta}
              isSticky={isSticky}
              navigation={navigation}
              isMobile={isMobile}
            />

            {displayAnchorMenuCta && (
              <div className="in-page-subnav--contextualCta">
                <ContentfulCallToAction {...contextualCta[0]} />
              </div>
            )}
          </InnerContainer>
        </Container>
      )}
      {displayMobileCta && <MobileCallToAction cta={contextualCta} />}
    </>
  );
};

export default AnchorLinkNavigation;
